import { FETCH_FLEETS_SUCCESS, UPDATE_FLEET_FOR_MAP } from "../action/fleet.action";

const initialState = {
  fleets : [{id:0, name:"My Fleet"}],
  showFleetIds: [0],
};

export default function fleetReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FLEET_FOR_MAP:
      return {
        ...state,
        showFleetIds : action.payload
      };
    case FETCH_FLEETS_SUCCESS:
      if (!_.isEmpty(action.payload)) {
        let fleetIds = action.payload.map((f) => {return f.id})
        let fleets = action.payload

        Object.assign(state.fleets, fleets);
        Object.assign(state.showFleetIds, fleetIds);
      }
      return {
        ...state,
      };
    default:
      return state;
  }
}